export default __webpack_public_path__ + "static/logo-white-aa535d091e7eefd8909d17d02aa4f145.png";